import { STATUS_LABELS, type InvoiceStatus } from '@/features/invoices/api'
import { cn } from '@/lib/cn'

/**
 * Same rule as the order badge: the label repeats whatever the colour says, because
 * "Overdue" and "Paid" cannot be allowed to depend on telling red from green.
 */
const TONES: Record<InvoiceStatus, string> = {
  draft: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  issued: 'bg-brand-500/10 text-brand-600 dark:text-brand-400',
  partially_paid: 'bg-warning/10 text-warning',
  paid: 'bg-success/10 text-success',
  overdue: 'bg-danger/10 text-danger',
  void: 'bg-slate-200 text-slate-500 line-through dark:bg-slate-700 dark:text-slate-400',
}

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  return (
    <span
      className={cn('rounded px-2 py-0.5 text-xs font-medium whitespace-nowrap', TONES[status])}
    >
      {STATUS_LABELS[status]}
    </span>
  )
}
